import Vue from 'vue';
import VueMoment from 'vue-moment'
import moment from 'moment-timezone'
moment.tz.setDefault('Africa/Cairo');
// moment.tz.setDefault('Asia/Riyadh');


Vue.use(VueMoment, {
    moment,
})